export const meta: BlockMeta = {
  title: "Themed Columns Item",
}

import { Themed } from "@components/atoms/Themed"
import { Button } from "@components/ui/Button"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { Link } from "eddev/routing"

export default defineBlock("content/themed-columns-item", (props) => {
  const theme = props.theme || "none"
  const Wrap = props.link ? Link : "div"
  const wrapProps = props.link ? { href: props.link.url, target: props.link.target || undefined } : {}

  return (
    <Wrap {...wrapProps} className={cn("w-full self-stretch flex", props.link && "group/linked")}>
      <Themed
        theme={theme}
        className={cn(
          "w-full p-6 md:p-5 self-stretch flex flex-col gap-5 md:gap-4 [&_.wp-block]:my-0 [&_.block-image]:my-0 [&_.block-image]:aspect-video [&_.block-image]:object-cover [&_.block-image_img]:object-cover [&_.block-image]:overflow-hidden [&_.block-image]:-ml-6 [&_.block-image]:w-[calc(100%+(var(--spacing-6)*2))] md:[&_.block-image]:-ml-5 md:[&_.block-image]:w-[calc(100%+(var(--spacing-5)*2))] [&_.image-caption]:!hidden [&_button]:my-0 [&_p]:my-0 [&_.core-rich-text]:flex [&_.core-rich-text]:flex-col [&_.core-rich-text]:gap-4 [&_.wp-block-heading]:my-0 [&_button]:!w-full [&_button]:!justify-start",
          theme === "none" && "bg-white",
        )}
      >
        <InnerBlocks
          allowedBlocks={["richtext"]}
          orientation="horizontal"
          adminClassName="w-full flex flex-col gap-4"
          template={[
            ["content/image", null],
            ["core/heading", { placeholder: "Example title", className: "is-style-medium" }],
            ["core/paragraph", { placeholder: "Example text" }],
          ]}
        />
      </Themed>
    </Wrap>
  )
})
